import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ReferenceService } from './services/reference.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ReferenceGuard  {
  constructor(private referenceService: ReferenceService, private router: Router,
    @Inject(DOCUMENT) private document:Document,
    @Inject(PLATFORM_ID) private platformId: Object) { }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<any> {
    let reference = "";
    if (route && route.params && route.params["reference"]) {
      reference = route.params["reference"];
      this.setCookie("referenceBhavani", reference, 3000, '/')
    } else if (route && route.params && route.queryParams["r"]) {
      reference = route.queryParams["r"];
      this.setCookie("referenceBhavani", reference, 3000, '/')
    } else if (route && route.params && !route.params["reference"] && !route.queryParams["r"]) {
      reference = this.getCookie("referenceBhavani")
    }

    const result = await this.checkAuthentication(reference).then((res) => true).catch(() => false)
    if (!result) this.router.navigate(["/welcome"])

    if (result) {
      // Generamos la URL base de la plataforma
      const platformBaseUrl = $localize.locale === 'es' ? `https://my.bhavani.app/es/registro` : `https://my.bhavani.app/en/registro`;
      window.location.href = `${platformBaseUrl}?r=${reference}`;
      return false;
    }
    return result
  }

  async checkAuthentication(reference: string): Promise<boolean> {
    const isAuthenticate: any = this.referenceService.checkRerefences(reference)
    return await lastValueFrom(isAuthenticate)
  }

  private setCookie(name: string, value: string, expireDays: number, path: string = '') {
    if (isPlatformBrowser(this.platformId)) {
      let d: Date = new Date();
      d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
      let expires: string = `expires=${d.toUTCString()}`;
      let cpath: string = path ? `; path=${path}` : '';
      this.document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }
  }

  private getCookie(name: string) {
    if (!isPlatformBrowser(this.platformId)) return '';
    let ca: Array<string> = this.document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
}
